var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1423 20.1663C6.07964 20.1663 1.97559 16.0622 1.97559 10.9997C1.97559 5.93706 6.07964 1.83301 11.1423 1.83301C16.2048 1.83301 20.3089 5.93706 20.3089 10.9997C20.3089 16.0622 16.2048 20.1663 11.1423 20.1663ZM11.1423 18.333C15.1924 18.333 18.4756 15.0498 18.4756 10.9997C18.4756 6.94958 15.1924 3.66634 11.1423 3.66634C7.09216 3.66634 3.80892 6.94958 3.80892 10.9997C3.80892 15.0498 7.09216 18.333 11.1423 18.333ZM8.39225 8.24967H10.2256V13.7497H8.39225V8.24967ZM12.0589 8.24967H13.8923V13.7497H12.0589V8.24967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.bf5fe5ab98119acea6ba145bbaa9368a.svg";
export { ForwardRef as ReactComponent };